import {
  FurnitureMasterListStateTypes,
  FurnitureMasterListActionTypes,
} from "./FurnitureMasterList.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FurnitureMasterListStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const FurnitureMasterReducer = (
  state: FurnitureMasterListStateTypes = INITIAL_STATE,
  action: any
): FurnitureMasterListStateTypes => {
  switch (action.type) {
    case FurnitureMasterListActionTypes.FETCH_ALL_FURNITURE_MASTER_LIST:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FurnitureMasterListActionTypes.FETCH_ALL_FURNITURE_MASTER_LIST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FurnitureMasterListActionTypes.FETCH_ALL_FURNITURE_MASTER_LIST_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FurnitureMasterListActionTypes.FETCH_ALL_FURNITURE_MASTER_LIST_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FurnitureMasterListActionTypes.FETCH_ONE_FURNITURE_MASTER_LIST:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FurnitureMasterListActionTypes.FETCH_ONE_FURNITURE_MASTER_LIST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case FurnitureMasterListActionTypes.FETCH_ONE_FURNITURE_MASTER_LIST_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FurnitureMasterListActionTypes.FETCH_ONE_FURNITURE_MASTER_LIST_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FurnitureMasterReducer;
